import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  // Utilizza un BehaviorSubject per tenere traccia delle notifiche non lette
  private unreadCountSource = new BehaviorSubject<number>(0);
  unreadCount$ = this.unreadCountSource.asObservable();

  constructor() {}

  // Metodo per aggiornare il numero delle notifiche non lette
  setUnreadCount(count: number) {
    this.unreadCountSource.next(count);
  }

  // Metodo per incrementare il numero delle notifiche non lette
  incrementUnreadCount() {
    this.unreadCountSource.next(this.unreadCountSource.value + 1);
  }

  // Metodo per resettare il conteggio delle notifiche
  resetUnreadCount() {
    this.unreadCountSource.next(0);
  }

  // Metodo per diminuire il conteggio delle notifiche di x
  /*
  diminuisciUnreadCount(x:number) {
    this.unreadCountSource.next(this.unreadCountSource.value - x);
  }*/
}